import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Wallet, ArrowUpRight, ArrowDownRight } from "lucide-react";

const TransactionsTable = ({ transactions = [], loading = false }) => {
  if (loading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center py-12 text-zinc-500">
        <Wallet className="w-12 h-12 mx-auto mb-4 text-zinc-300" />
        <p>No tienes movimientos aún</p>
        <p className="text-sm">Recarga tu saldo para comenzar</p>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      "completed": { class: "bg-emerald-100 text-emerald-700", label: "Completado" },
      "pending": { class: "bg-amber-100 text-amber-700", label: "Pendiente" },
      "failed": { class: "bg-red-100 text-red-700", label: "Fallido" }
    };

    const config = statusMap[status] || statusMap.pending;
    return <Badge className={config.class}>{config.label}</Badge>;
  };

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Tipo</TableHead>
            <TableHead>Descripción</TableHead>
            <TableHead>Monto</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead>Fecha</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {transactions.map((txn) => (
            <TableRow key={txn.transaction_id} data-testid={`transaction-row-${txn.transaction_id}`}>
              <TableCell>
                {txn.amount > 0 ? (
                  <div className="flex items-center gap-1 text-emerald-600">
                    <ArrowDownRight className="w-4 h-4" />
                    <span>Recarga</span>
                  </div>
                ) : (
                  <div className="flex items-center gap-1 text-red-600">
                    <ArrowUpRight className="w-4 h-4" />
                    <span>Envío</span>
                  </div>
                )}
              </TableCell>
              <TableCell className="text-sm max-w-[200px] truncate">
                {txn.description}
              </TableCell>
              <TableCell className={`font-medium ${txn.amount > 0 ? "text-emerald-600" : "text-red-600"}`}>
                {txn.amount > 0 ? "+" : ""}{txn.amount?.toFixed(2)} MXN
              </TableCell>
              <TableCell>{getStatusBadge(txn.status)}</TableCell>
              <TableCell className="text-sm text-zinc-500">
                {formatDate(txn.created_at)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TransactionsTable;
